module.exports = __webpack_public_path__ + "static/media/share-2.69e17e4f.png";